module.exports = __webpack_public_path__ + "img/entrep-home-image.e9c25446.jpg";